export class ObjectUtility {
  static copyShallowly(source: any): any {
    return this.copy(source, (s, a) => this.mergeShallowly(s, a));
  }

  static copyDeeply(source: any): any {
    return this.copy(source, (s, a) => this.mergeDeeply(s, a));
  }

  // classとかを使ってない原始的な構造をdeepcopyする実装.
  // copyDeeplyだとDateがただのobjectになるのでその対策版.
  // copyDeeplyを置き換えるのは影響を読み切れないのと、独自クラス以外を使ってた時の対応を考えると、Dateだけ特別扱いするのも微妙.
  // なので原始的な構造用として実装追加する.
  static copyAtomicDeeply<T>(source: T): T {
    return this.copy(source, (s, a) => this.mergeAtomicDeeply(s, a));
  }

  private static copy(source: any, merge: (s: any, a: any) => any) {
    return this.isValid(source)
      ? merge(this.createEmpty(source), source)
      : source;
  }

  private static createEmpty(source: any) {
    if (Array.isArray(source)) {
      return [];
    } else if (typeof source === "object") {
      return {};
    } else {
      return source;
    }
  }

  static mergeShallowly(source: any, additional: any) {
    return this.merge(source, additional, false);
  }

  static mergeDeeply(source: any, additional: any) {
    return this.merge(source, additional, true);
  }

  static mergeAtomicDeeply(source: any, additional: any): any {
    // Dateの救済措置だけ.後は通常と一緒.
    return additional instanceof Date
      ? new Date(additional)
      : this.merge(source, additional, true, {
        merge: (s, a, isDeeply) => this.mergeAtomicDeeply(s, a),
        mergeArray: (s, a, isDeeply) => a.map(v => this.mergeAtomicDeeply(undefined, v)),
      });
  }

  private static merge(source: any, additional: any, isDeeply: boolean, options?: IMergeOptions): any {
    if (!this.isValid(additional)) {
      return this.isValid(source)
        ? source
        : additional;
    } else if (!this.isValid(source) || (typeof source !== "object") || (typeof additional !== "object")) {
      return (Array.isArray(additional) || (typeof additional === "object"))
        ? ((options && options.merge) ? options.merge(this.createEmpty(additional), additional, isDeeply) : this.merge(this.createEmpty(additional), additional, isDeeply))
        : additional;
    } else if (Array.isArray(additional)) {
      return (options && options.mergeArray)
        ? options.mergeArray(source, additional, isDeeply)
        : additional;
    } else {
      for (const key of Object.keys(additional)) {
        source[key] = isDeeply
          ? ((options && options.merge) ? options.merge(source[key], additional[key], true) : this.merge(source[key], additional[key], true))
          : additional[key];
      }
      return source;
    }
  }

  private static isValid(source: any): boolean {
    return (source !== undefined)
        && (source !== null);
  }
}

interface IMergeOptions {
  merge?: (source: any, additional: any, isDeeply: boolean) => any;
  mergeArray?: (source: any, additional: any[], isDeeply: boolean) => any[];
}
